<template>
  <div v-if="promotion">
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      招待キャンペーン
    </Header>

    <div class="banner-background p-3">
      <div class="banner-section-background">
        <div class="d-flex">
          <div
            class="d-flex flex-column align-items-center pt-3 pb-2 pl-3 banner-main-text"
            data-testid="banner-referrer-main-text"
          >
            <span
              class="text-bolder text-nowrap d-flex justify-content-between w-100"
            >
              <span class="font-weight-bold highlight mr-1">\</span>
              <span>招待してくれたあなたに</span>
              <span class="font-weight-bold highlight ml-1">/</span>
            </span>
            <span>
              <span class="text-size-48 font-weight-bolder highlight">{{
                formattedReferPromotionPoint
              }}</span
              ><span class="text-size-20 font-weight-bolder highlight">pt</span>
              <span class="text-size-10">※</span>
            </span>
            <span
              class="text-bolder text-nowrap d-flex justify-content-between w-100"
            >
              <span class="font-weight-bold highlight mr-1">/</span>
              <span>プレゼント</span>
              <span class="font-weight-bold highlight ml-1">\</span>
            </span>
            <span
              class="d-flex justify-content-start align-items-baseline w-100 mt-2 "
              data-testid="banner-referrer-annotation-text"
            >
              <span class="text-size-10">※</span>
              <span class="text-size-12 text-bolder"
                >{{ yenConversionReferPoint }}円</span
              >
              <span class="text-size-10">相当</span>
            </span>
          </div>
          <div class="d-flex align-items-center ml-auto">
            <img
              class="banner-img pr-2"
              src="@/assets/svg/caikuma_invitation_campaign.svg?webp"
            />
          </div>
        </div>
      </div>
      <div class="mt-3 d-flex justify-content-center">
        <p class="text-size-12 text-bolder">
          あなたのご招待が介護・医療業界の支えになります
        </p>
      </div>
      <div class="banner-subsection-container mt-3">
        <div class="banner-subsection">
          有資格者の<br /><span class="highlight"
            >スキマ時間が<br />社会に役立つ</span
          >
        </div>
        <div class="banner-subsection">
          現場の<span class="highlight"
            >人材不足<br />解消やサービス<br />向上</span
          >に繋がる
        </div>
        <div class="banner-subsection">
          利用者・患者に<br /><span class="highlight"
            >サービスが<br />行き届く</span
          >
        </div>
      </div>
      <p class="d-flex justify-content-center mt-3 text-bolder">
        ぜひご協力をお願いします！
      </p>
      <div>
        <p class="d-flex justify-content-center text-size-14 mr-2">
          カイテクへの招待を投稿する
        </p>
        <SNSLink @click="onClickSNSLink" />
      </div>
    </div>
    <div>
      <ReferNav />
    </div>
    <div class="refer-promotion px-3 pt-3">
      <ReferrerTab
        v-if="isActiveTab('referrer')"
        :promotion="promotion"
        :pointAppliedPromotion="pointAppliedPromotion"
        :countAppliedPromotion="countAppliedPromotion"
        :userData="userData"
        @click="copyPromotionCode"
      />

      <ReferredTab
        v-else-if="isActiveTab('referred')"
        v-model:promotionCode="promotionCode"
        :alreadyReferred="alreadyReferred"
        :alreadyWorked="alreadyWorked"
        :canApplyPromotion="canApplyPromotion"
        @click="applyPromotion"
      />
    </div>
  </div>
</template>

<script lang="ts">
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import BgWaveCard from "@/components/organisms/common/BgWaveCard.vue";
import SNSLink from "@/components/organisms/mypage/SNSLink.vue";
import { accountService } from "@/app/services/AccountService";
import { Component, Vue } from "vue-facing-decorator";
import { ReferPromotion } from "@/types/refer_promotion/ReferPromotion";
import { copyToClipboard } from "@/utils/clipboard";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { routerPush } from "@/utils/routerPush";
import { ReferPromotionLog } from "@/types/refer_promotion/ReferPromotionLog";
import { User } from "@/types/user/User";
import { formatNumber } from "@/utils/number";
import { systemService } from "@/app/services/SystemService";
import { ReferPromotionPoint } from "@/types/system/ReferPromotionPoint";
import { SnsPlatform } from "@/types/sns/SnsPlatform";
import ExternalLink from "@/const/externalLink";
import { openInNewWindow } from "@/utils/browserUtil";
import TextFieldGroup from "@/components/molecules/form/TextFieldGroup.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import ReferrerTab from "@/components/organisms/mypage/referPromotion/ReferrerTab.vue";
import ReferredTab from "@/components/organisms/mypage/referPromotion/ReferredTab.vue";
import { routerReplace } from "@/utils/routerReplace";
import ReferNav from "@/components/organisms/mypage/referPromotion/ReferNav.vue";
import { PointHistory } from "@/types/worker/PointHistory";
import { subDays, parseISO, startOfToday } from "@/utils/date";

type TabType = "referrer" | "referred";

@Component({
  components: {
    FeatherIcon,
    Header,
    BgWaveCard,
    SNSLink,
    TextFieldGroup,
    AppButton,
    ReferrerTab,
    ReferredTab,
    ReferNav
  }
})
export default class ReferPromotionIndex extends Vue {
  promotion: ReferPromotion | null = null;
  promotionLogs: ReferPromotionLog[] = [];
  referredLog: ReferPromotionLog | null = null;
  referPromotionPoint: ReferPromotionPoint | null = null;
  userData: User | null = null;
  qualificationFirstVerifiedAt: string | null = null;
  referrerRoute = { name: "ReferPromotion", query: { tab: "referrer" } };
  referredRoute = { name: "ReferPromotion", query: { tab: "referred" } };
  promotionCode = "";
  pointHistory: PointHistory[] = [];
  isPromotionApplied = false;

  async created() {
    try {
      this.$loading.show();
      await Promise.all([
        this.fetchReferPromotion(),
        this.fetchReferPromotionLog(),
        this.fetchReferredPromotionLog(),
        this.fetchUserData(),
        this.fetchReferPromotionPoint(),
        this.fetchPointHistory(),
        this.fetchQualificationFirstVerifiedAt()
      ]);
      this.setPromotionCode();
      this.setActiveTab();
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  get activeTab() {
    return this.$route.query.tab as TabType;
  }

  get yenConversionReferPoint() {
    return formatNumber(this.referPromotionPoint?.yenConversionReferPoint ?? 0);
  }

  get formattedReferPromotionPoint() {
    return formatNumber(this.referPromotionPoint?.referPoint ?? 0);
  }

  get yenConversionReferredPoint() {
    return formatNumber(
      this.referPromotionPoint?.yenConversionReferredPoint ?? 0
    );
  }

  get formattedReferredPromotionPoint() {
    return formatNumber(this.referPromotionPoint?.referredPoint ?? 0);
  }

  get countAppliedPromotion() {
    return this.promotionLogs.filter(log => log.isApplied).length;
  }

  get pointAppliedPromotion() {
    return this.pointHistory.reduce(
      (acc, history) => acc + history.deltaPoint,
      0
    );
  }

  get alreadyWorked() {
    if (!this.userData) return false;
    return this.userData.workCount > 0;
  }

  get alreadyReferred() {
    return !!this.referredLog;
  }

  get isAfter31DaysToQualificationVerification() {
    if (!this.qualificationFirstVerifiedAt) return false;
    return (
      parseISO(this.qualificationFirstVerifiedAt) < subDays(startOfToday(), 31)
    );
  }

  get canApplyPromotion() {
    return (
      !this.isPromotionApplied &&
      !this.alreadyReferred &&
      !this.alreadyWorked &&
      !this.isAfter31DaysToQualificationVerification
    );
  }

  async onClickBack() {
    await routerPush(this, { name: "Mypage" });
  }

  async fetchReferPromotion() {
    this.promotion = await accountService.fetchReferPromotion();
  }

  async fetchReferPromotionLog() {
    const response = await accountService.fetchReferPromotionLog();
    this.promotionLogs = response.results;
  }

  async fetchReferredPromotionLog() {
    const response = await accountService.fetchReferredPromotionLog();
    this.referredLog = response.results[0];
  }

  async fetchReferPromotionPoint() {
    this.referPromotionPoint = await systemService.fetchReferPromotionPoint();
  }

  async fetchUserData() {
    this.userData = await accountService.fetchUserData();
  }

  async fetchQualificationFirstVerifiedAt() {
    const response = await accountService.fetchQualificationFirstVerifiedAt();
    this.qualificationFirstVerifiedAt = response.qualificationFirstVerifiedAt;
  }

  async copyPromotionCode() {
    if (!this.promotion?.code) return;
    const isSucceeded = await copyToClipboard(this.promotion.code);
    if (isSucceeded) {
      await this.$bvModal.msgBoxOk(
        "招待コードをクリップボードにコピーしました",
        { centered: true }
      );
    } else {
      await this.$bvModal.msgBoxOk(
        "招待コードのクリップボードへのコピーに失敗しました",
        { centered: true }
      );
    }
  }

  generateShareLink(platform: SnsPlatform) {
    const messages = {
      line: {
        text: `「カイテク」は、面接・履歴書不要で好きな時に、1日だけ、短時間でも働ける便利なアプリ！給与も退勤後約5分で受け取れる💡
              【招待コード: ${this.promotion?.code}】
              早速アプリをインストールして、一緒にカイテクで働きましょう！👋\n`,
        url: ExternalLink.DOWNLOAD_LINK_FOR_LINE
      },
      email: {
        text: `「カイテク」は、面接・履歴書不要で好きな時に、1日だけ、短時間でも働ける便利なアプリ！給与も退勤後約5分で受け取れる💡
              【招待コード: ${this.promotion?.code}】
              早速アプリをインストールして、一緒にカイテクで働きましょう！👋\n`,
        url: ExternalLink.DOWNLOAD_LINK_FOR_EMAIL
      },
      x: {
        text: `カイテクは、面接なしで1日から好きな時に働ける便利なアプリ！給与も退勤後約5分で受け取れる💡
              【招待コード: ${this.promotion?.code}】
              招待コードを登録して、一緒にカイテクで働きましょう👋\n`,
        url: ExternalLink.DOWNLOAD_LINK_FOR_X
      },
      facebook: {
        // NOTE: facebookはテキストのシェアができないため、URLのみをシェアする
        text: "",
        url: ExternalLink.DOWNLOAD_LINK_FOR_FACEBOOK
      }
    };

    const message = messages[platform];

    if (!message) {
      return "";
    }

    const encodedText = encodeURIComponent(
      message.text.replace(/\n\s+/g, "\n")
    );
    const encodedUrl = encodeURIComponent(message.url);

    switch (platform) {
      case "line":
        return `https://line.me/R/msg/text/?${encodedText}\n${encodedUrl}`;
      case "email":
        return `mailto:?subject=${encodeURIComponent(
          "カイテクで働いてみませんか？"
        )}&body=${encodedText}%0A${encodedUrl}`;
      case "x":
        return `https://twitter.com/intent/tweet?text=${encodedText}\n${encodedUrl}`;
      case "facebook":
        return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      default:
        return "";
    }
  }

  onClickSNSLink(platform: SnsPlatform) {
    const link = this.generateShareLink(platform);
    if (!link) {
      return;
    }

    openInNewWindow(link);
  }

  isActiveTab(expectedTab: TabType) {
    return this.activeTab === expectedTab;
  }

  setPromotionCode() {
    if (!this.referredLog) {
      return;
    }
    this.promotionCode = this.referredLog.promotionCode;
  }

  setActiveTab() {
    if (this.canApplyPromotion) {
      routerReplace(this, this.referredRoute);
    } else {
      routerReplace(this, this.referrerRoute);
    }
  }

  async fetchPointHistory() {
    const { results } = await accountService.fetchPointHistoryList({
      limit: 9999,
      offset: 0,
      operation_type: "refer_promotion"
    });
    this.pointHistory = results;
  }

  async applyPromotion() {
    try {
      this.$loading.show();
      await accountService.applyReferPromotionCode({
        code: this.promotionCode!
      });
      this.isPromotionApplied = true;
      await this.$bvModal.msgBoxOk("招待コードが登録されました。", {
        centered: true
      });
    } catch (error) {
      await showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }
}
</script>

<style lang="scss" scoped>
.text-bolder {
  font-weight: 500;
}

.banner-background {
  background-color: #fbce5a;
}

.banner-section-background {
  background-color: $white;
  border-radius: 10px;

  .banner-section-footer {
    background-color: #fff6e0;
    border-radius: 0 0 10px 10px;
  }
}

.banner-main-text {
  line-height: 1.25;
}

.banner-subsection-container {
  display: flex;
  gap: 4px;
}

.banner-subsection {
  flex: 1;
  padding: 4px;
  font-size: 12px;
  text-align: center;
  background-color: $white;
  border-radius: 5px;
}

.text-size-48 {
  font-size: 48px;
}

.section-title {
  font-weight: 500;
}

.banner-img {
  width: 100%;
  max-width: 100%;
  height: auto;
}

.annotation-text {
  color: $gray-05;
}

.highlight {
  color: #f4a722;
}

.refer-promotion {
  .section3 {
    .d-flex .flex-grow-1 {
      max-width: 90%;
    }
  }
}
</style>
